import { render, staticRenderFns } from "./Formandos.vue?vue&type=template&id=6c1eceac&scoped=true&"
import script from "./Formandos.vue?vue&type=script&lang=js&"
export * from "./Formandos.vue?vue&type=script&lang=js&"
import style0 from "./Formandos.vue?vue&type=style&index=0&id=6c1eceac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1eceac",
  null
  
)

export default component.exports